<template>
  <div class="month-container">
    <div class="month-label">
      <h1>{{ monthName }}</h1>
      <div class="circle" />
    </div>

    <ul class="month-record-list">
      <RecordItem v-for="(record, index) in props.records" :key="index" :record="record" />
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import RecordItem from '@/components/profile/PersonalRecordListItem.vue';

const props = defineProps({
  month: {
    type: Number,
    default: 0,
    validator(month) {
      // must be 0 - 11, corresponding to month
      return month >= 0 && month <= 11;
    },
  },
  records: {
    type: Array,
    default: () => [],
  },
  first: Boolean, // used because I wasn't able to get the first-of-type css to work
});

const monthName = computed(() => {
  return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][props.month];
});
</script>

<style scoped>
.month-label {
  position: relative;
}
.month-label h1 {
  margin: 0 0 0.5em;
  color: #a7a9ac;
  text-transform: uppercase;
}
.month-label .circle {
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translate(-50%, calc(100% + 0.5em));

  box-sizing: border-box;
  width: 0.8em;
  height: 0.8em;
  border: 1px solid #a7a9ac;
  border-radius: 50%;
  background: white;
}

.month-record-list {
  margin: 0;
  border-left: 1px solid #a7a9ac;
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .month-container {
    margin-left: 2em;
  }

  .month-label {
    display: flex;
    align-items: center;
  }

  .month-label h1 {
    position: absolute;
    transform: translate(calc(-100% - 0.5em), 0);
  }

  .month-label .circle {
    transform: translate(-50%, 0);
  }

  .month-record-list {
    padding: 0 0 5em;
    border-left: 1px solid #a7a9ac;
  }
}
</style>
